import React, { useEffect, useState } from "react";
import { Button, BodyText, DetailText } from "@src/components/nessie-web";
import CommonModal from "@src/components/modals/CommonModal";
import styled from "@emotion/styled";
import { logEvent } from "@src/utils/logClient";

type CalendlyModalProps = {
  calendlyLink: string;
  closeModal: () => void;
  logEventContext: string;
};

const CaptchaContainer = styled("div")`
  margin-top: 80px;
  height: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
`;

const StyledInput = styled.input`
  border: 1px solid #ccc;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  height: 49px;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.33;
  border-radius: 5px;
  margin: 1px;
  border-radius: 15px;
  width: 100%;
`;

const CalendarIframe = styled("iframe")`
  width: 100%;
  height: calc(100vh - 100px);
  margin: 24px 0;
  border: 0;
  border-radius: 24px;
`;

const numberNames = {
  0: "zero",
  1: "one",
  2: "two",
  3: "three",
  4: "four",
  5: "five",
  6: "six",
  7: "seven",
  8: "eight",
  9: "nine",
};

const CalendlyModal: React.FC<CalendlyModalProps> = ({ calendlyLink, closeModal, logEventContext }) => {
  const [captcha, setCaptcha] = useState({
    inputValue: "",
    question: "",
    answer: "",
    valid: false,
    error: false,
  });

  useEffect(() => {
    generateCaptcha();
  }, []);

  function generateCaptcha() {
    const a = Math.floor(Math.random() * 10);
    const b = Math.floor(Math.random() * 10);
    const answer = a + b;
    setCaptcha({
      inputValue: "",
      question: `How much is ${numberNames[a]} plus ${numberNames[b]}?`,
      answer: answer.toString(),
      valid: false,
      error: false,
    });
  }

  function handleCaptchaChange(event) {
    setCaptcha({
      ...captcha,
      inputValue: event.target.value,
    });
  }

  function submitCaptcha() {
    if (captcha.inputValue === captcha.answer) {
      setCaptcha({ ...captcha, valid: true });
      logEvent({
        eventName: `web.external.${logEventContext}.show_calendly_ui`,
        eventValue: window.location.href,
      });
    } else {
      generateCaptcha();
      setCaptcha({ ...captcha, error: true, inputValue: "" });
      logEvent({
        eventName: `web.external.${logEventContext}.fail_captcha`,
        eventValue: window.location.href,
      });
    }
  }

  return (
    <CommonModal fullScreen noHeader closeModal={closeModal}>
      {!captcha.valid ? (
        <CaptchaContainer>
          <BodyText>{captcha.question}</BodyText>
          <StyledInput
            id="captcha"
            name="captcha"
            type="text"
            value={captcha.inputValue}
            onChange={handleCaptchaChange}
            required
          />
          <DetailText>{captcha.error ? "Invalid answer!" : "Enter your answer as a number (1, 2, 3...)"}</DetailText>
          <Button kind="plus" onClick={submitCaptcha}>
            Verify
          </Button>
        </CaptchaContainer>
      ) : (
        <CalendarIframe src={calendlyLink} />
      )}
    </CommonModal>
  );
};

export default CalendlyModal;
